import type { SVGProps } from 'react';

export const InputTextArea = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'input textarea'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="16" cy="16" fill="#F2F4F9" r="16" />
      <g transform="translate(6, 8)">
        <g transform="translate(0.0001, 3.75)">
          <polygon points="0 0 19.9999 0 19.9999 1.25 0 1.25" />
          <path
            d="M19.64275,1.25 L0.357,1.25 C0.15975,1.25 0,1.138 0,1 L0,0.25 C0,0.112 0.15975,0 0.357,0 L19.64275,0 C19.84,0 20,0.112 20,0.25 L20,1 C20,1.138 19.84,1.25 19.64275,1.25"
            fill="#898C9A"
          />
        </g>
        <g transform="translate(0.0001, 0)">
          <polygon points="0 0 19.9999 0 19.9999 1.25 0 1.25" />
          <path
            d="M19.64275,1.25 L0.357,1.25 C0.15975,1.25 0,1.138 0,1 L0,0.25 C0,0.112 0.15975,0 0.357,0 L19.64275,0 C19.84,0 20,0.112 20,0.25 L20,1 C20,1.138 19.84,1.25 19.64275,1.25"
            fill="#898C9A"
          />
        </g>
        <g transform="translate(0.0001, 7.5)">
          <polygon points="0 0 19.9999 0 19.9999 1.25 0 1.25" />
          <path
            d="M19.64275,1.25 L0.357,1.25 C0.15975,1.25 0,1.138 0,1 L0,0.25 C0,0.112 0.15975,0 0.357,0 L19.64275,0 C19.84,0 20,0.112 20,0.25 L20,1 C20,1.138 19.84,1.25 19.64275,1.25"
            fill="#898C9A"
          />
        </g>
        <g transform="translate(0.0001, 11.25)">
          <polygon points="0 0 19.9999 0 19.9999 1.25 0 1.25" />
          <path
            d="M19.64275,1.25 L0.357,1.25 C0.15975,1.25 0,1.138 0,1 L0,0.25 C0,0.112 0.15975,0 0.357,0 L19.64275,0 C19.84,0 20,0.112 20,0.25 L20,1 C20,1.138 19.84,1.25 19.64275,1.25"
            fill="#898C9A"
          />
        </g>
        <g transform="translate(0, 15)">
          <polygon points="0 0 9.999925 0 9.999925 1.25 0 1.25" />
          <path
            d="M9.821425,1.25 L0.178675,1.25 C0.079925,1.25 -7.5e-05,1.138 -7.5e-05,1 L-7.5e-05,0.25 C-7.5e-05,0.112 0.079925,0 0.178675,0 L9.821425,0 C9.919925,0 9.999925,0.112 9.999925,0.25 L9.999925,1 C9.999925,1.138 9.919925,1.25 9.821425,1.25"
            fill="#898C9A"
          />
        </g>
      </g>
    </g>
  </svg>
);
